// extracted by mini-css-extract-plugin
module.exports = {"container":"CardContainer_container__av6Y0","title":"CardContainer_title__1tAAf","subTitle":"CardContainer_subTitle__1z8f3"};